import { render, staticRenderFns } from "./CategoryReporting.vue?vue&type=template&id=5a216dc8&scoped=true"
import script from "./CategoryReporting.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryReporting.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a216dc8",
  null
  
)

export default component.exports